import ErrorBlock, { ErrorBlockProps } from './ErrorBlock';

export type { ErrorBlockProps };
export default ErrorBlock;
